import React from 'react';

import styled from 'styled-components';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import { NwCard } from '@components/Gui/NwCard/NwCard';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const StyledCard = styled(NwCard)`
    .connection-item {
        border-bottom: ${(props) => props.theme.DefaultBorder};
        &:last-child {
            border-bottom: none;
        }

        padding: 1rem;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 2rem;
        cursor: pointer;
        &:hover {
            background-color: ${(props) => props.theme.HoverablesBackground};
        }

        em {
            font-style: normal;
            display: block;
            font-size: ${(props) => props.theme.FontSizeSm};
            text-transform: uppercase;
        }
        strong {
            display: block;
        }
    }
`;

const AddCallSheetContactCard = ({ contact, onClick }) => {
    return (
        <StyledCard title={contact.Name} key={contact.ContactID} icon={byPrefixAndName.fasl['address-card']}>
            {contact.Connections.length === 0 && <p>no connections found</p>}
            {contact.Connections.map((connection) => (
                <div key={connection.ID} className="connection-item" onClick={() => onClick(connection)}>
                    <div className="contact-list-icon">
                        <NwIcon
                            icon={
                                connection.TypeName === 'Place'
                                    ? byPrefixAndName.fasl['home-alt']
                                    : byPrefixAndName.fasl['user']
                            }
                        />
                    </div>
                    {connection.TypeName === 'People' ? (
                        <div className="contact-list-details">
                            {connection.Role && <em>{connection.Role}</em>}
                            <strong>
                                {connection.Name} {connection.Surname}
                            </strong>
                        </div>
                    ) : (
                        <div className="contact-list-details">
                            <div className="contact-connection-name">{connection.ContactName}</div>
                            <div className="contact-name">{connection.Name}</div>
                        </div>
                    )}
                </div>
            ))}
        </StyledCard>
    );
};

export default AddCallSheetContactCard;
